import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { CostCentersStructureDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

import { CostCentersNestedList } from 'modules/cost_centers/components/CostCenterNestedList'
import { EmptyCostCentersStructure } from 'modules/cost_centers/components/CostCentersStructure/EmptyState'
import { PendingStatuses } from 'modules/cost_centers/components/CostCentersStructure/types'
import { useCostCenterConfiguration } from 'modules/cost_centers/hooks/useCostCenterConfiguration'

import { CostCenterConfiguration } from './Configuration'

const CostCentersStructure = ({ canManageCostCenters }: { canManageCostCenters: boolean }) => {
  const [configure, setConfigure] = useState<boolean>(false)

  const { data: structureData, loading: structureLoading } = useQuery(CostCentersStructureDocument)

  const { configurations, isLoading: isLoadingConfigurations } = useCostCenterConfiguration()

  const hasConfigurationPending = useUnsafeMemo(() => {
    return !!configurations?.find(({ processingStatus }) => {
      return PendingStatuses.includes(processingStatus)
    })
  }, [configurations])

  if (structureLoading || isLoadingConfigurations) {
    return (
      <Box flexGrow justifyContent="center" alignItems="center">
        <Loading />
      </Box>
    )
  }

  if (configure) {
    return <CostCenterConfiguration data={structureData} cancel={() => setConfigure(false)} />
  }

  if (configurations.length === 0 || hasConfigurationPending) {
    return (
      <EmptyCostCentersStructure
        hasConfigurationPending={hasConfigurationPending}
        canManageCostCenters={canManageCostCenters}
        hasWorkplaces={!!structureData?.locations?.locations?.length}
        hasJobCatalog={!!structureData?.jobCatalog?.treesConnection?.nodes?.length}
        startConfiguration={() => setConfigure(true)}
      />
    )
  }

  return (
    <CostCentersNestedList
      canManageCostCenters={canManageCostCenters}
      configurations={configurations}
    />
  )
}

export { CostCentersStructure }
